export default "<div class=\"field-label\" i18n>{{label}}</div>\n<app-switch class=\"ml-2\" [control]=\"control\"></app-switch>"